module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.fatorRiscoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Laboratorios', {
    attrs: {
      "parent": this
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a306b03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/fator-risco/editar.vue
// module id = 1561
// module chunks = 45